module.exports = __webpack_public_path__ + "img/correto.97076ee4.svg";